import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface UEStreamingsKeyType {
  openCameraMenu: LocalesKey;
  closeCameraMenu: LocalesKey;
  cameraSettings: LocalesKey;
  enterFullscreen: LocalesKey;
  exitFullscreen: LocalesKey;
  exitStudio: LocalesKey;
  saveCurrentView: LocalesKey;
  aspectRatioPanel: LocalesKey;
  helpNavTitle: LocalesKey;
  helpCaptureTitle: LocalesKey;
  helpCameraTitle: LocalesKey;
  helpSceneTitle: LocalesKey;
  helpNavDrag: LocalesKey;
  helpNavScroll: LocalesKey;
  helpNavMove: LocalesKey;
  helpNavHeight: LocalesKey;
  helpCapturePhoto: LocalesKey;
  helpCameraSaveView: LocalesKey;
  helpCameraLoadView: LocalesKey;
  helpSceneSave: LocalesKey;
  helpSceneApply: LocalesKey;
  helpSceneUndoRedo: LocalesKey;
  helpSceneFocus: LocalesKey;
  helpNavCameraPanel: LocalesKey;
  helpExportTask: LocalesKey;
  helpSettingsTitle: LocalesKey;
  helpSettingsCamera: LocalesKey;
  helpSettingsSun: LocalesKey;
  helpSettingsAtm: LocalesKey;
  helpAspectTitle: LocalesKey;
  helpAspectDesc: LocalesKey;
  helpSavesReset: LocalesKey;
  helpSavesRestore: LocalesKey;
  helpSavesResetCamera: LocalesKey;
  helpAspect16x9: LocalesKey;
  helpAspect9x16: LocalesKey;
  helpAspect4x3: LocalesKey;
  helpAspect1x1: LocalesKey;
  helpAspectAuto: LocalesKey;
  helpAspectCustom: LocalesKey;
  systemSettings: LocalesKey;
  nanite: LocalesKey;
  deleteSave: LocalesKey;
  deleteSaveActiveWarning: LocalesKey;
  deleteCamera: LocalesKey;
  // Studio toolbar
  grayscaleMode: LocalesKey;
  selectionTrace: LocalesKey;
  undo: LocalesKey;
  redo: LocalesKey;
  exportSettingsToTask: LocalesKey;
  // Take picture
  takePicture: LocalesKey;
  processing: LocalesKey;
  // Loading / queue
  establishingConnection: LocalesKey;
  queuePosition: LocalesKey;
  estimatedWait: LocalesKey;
  doNotNavigateAway: LocalesKey;
  tryAgain: LocalesKey;
  // Camera settings tabs
  tabCamera: LocalesKey;
  tabSun: LocalesKey;
  tabAtmosphere: LocalesKey;
  tabPostproduction: LocalesKey;
  tabScene: LocalesKey;
  // Move + orientation
  cameraMove: LocalesKey;
  orientation: LocalesKey;
  stepSize: LocalesKey;
  panAngle: LocalesKey;
  tiltAngle: LocalesKey;
  // Interior lights
  interiorLightsScale: LocalesKey;
  // Sun tab section titles
  sunPosition: LocalesKey;
  sunParameters: LocalesKey;
  // Saved cameras panel
  cameras: LocalesKey;
  noCameras: LocalesKey;
  savedCameras: LocalesKey;
  // Saves panel
  saves: LocalesKey;
  noSaves: LocalesKey;
  sceneSaves: LocalesKey;
  saveView: LocalesKey;
  // Center stage dock toggles
  showCameraMovePanel: LocalesKey;
  hideCameraMovePanel: LocalesKey;
  showHidePanels: LocalesKey;
  // Scene-tab actor lists
  hideLists: LocalesKey;
  showLists: LocalesKey;
  // Section titles (CameraTab)
  sectionLens: LocalesKey;
  sectionDepthOfField: LocalesKey;
  sectionMovement: LocalesKey;
  sectionPerspective: LocalesKey;
  // CameraTab slider labels
  correctionStrength: LocalesKey;
  focalLength: LocalesKey;
  clippingPlane: LocalesKey;
  fStop: LocalesKey;
  focusDistance: LocalesKey;
  movementSpeed: LocalesKey;
  rotationSpeed: LocalesKey;
  cameraBounds: LocalesKey;
  // AtmosphereTab slider labels
  skyLightIntensity: LocalesKey;
  fogDensity: LocalesKey;
  // PostproductionTab slider labels
  exposure: LocalesKey;
  // SunTab slider labels
  sunPitch: LocalesKey;
  sunYaw: LocalesKey;
  sunIntensity: LocalesKey;
  sunTemperature: LocalesKey;
  sunLightSourceAngle: LocalesKey;
  autoVerticalAlignment: LocalesKey;
  sectionExposureAndInterior: LocalesKey;
  sectionSkyAndFog: LocalesKey;
  sectionFogColor: LocalesKey;
  sectionMeshes: LocalesKey;
  sectionLights: LocalesKey;
}

export const ueStreamingsKeys = keyPathMirror<UEStreamingsKeyType, string>(
  {
    openCameraMenu: null,
    closeCameraMenu: null,
    cameraSettings: null,
    enterFullscreen: null,
    exitFullscreen: null,
    exitStudio: null,
    saveCurrentView: null,
    aspectRatioPanel: null,
    helpNavTitle: null,
    helpCaptureTitle: null,
    helpCameraTitle: null,
    helpSceneTitle: null,
    helpNavDrag: null,
    helpNavScroll: null,
    helpNavMove: null,
    helpNavHeight: null,
    helpCapturePhoto: null,
    helpCameraSaveView: null,
    helpCameraLoadView: null,
    helpSceneSave: null,
    helpSceneApply: null,
    helpSceneUndoRedo: null,
    helpSceneFocus: null,
    helpNavCameraPanel: null,
    helpExportTask: null,
    helpSettingsTitle: null,
    helpSettingsCamera: null,
    helpSettingsSun: null,
    helpSettingsAtm: null,
    helpAspectTitle: null,
    helpAspectDesc: null,
    helpSavesReset: null,
    helpSavesRestore: null,
    helpSavesResetCamera: null,
    helpAspect16x9: null,
    helpAspect9x16: null,
    helpAspect4x3: null,
    helpAspect1x1: null,
    helpAspectAuto: null,
    helpAspectCustom: null,
    systemSettings: null,
    nanite: null,
    deleteSave: null,
    deleteSaveActiveWarning: null,
    deleteCamera: null,
    grayscaleMode: null,
    selectionTrace: null,
    undo: null,
    redo: null,
    exportSettingsToTask: null,
    takePicture: null,
    processing: null,
    establishingConnection: null,
    queuePosition: null,
    estimatedWait: null,
    doNotNavigateAway: null,
    tryAgain: null,
    tabCamera: null,
    tabSun: null,
    tabAtmosphere: null,
    tabPostproduction: null,
    tabScene: null,
    cameraMove: null,
    orientation: null,
    stepSize: null,
    panAngle: null,
    tiltAngle: null,
    interiorLightsScale: null,
    sunPosition: null,
    sunParameters: null,
    cameras: null,
    noCameras: null,
    savedCameras: null,
    saves: null,
    noSaves: null,
    sceneSaves: null,
    saveView: null,
    showCameraMovePanel: null,
    hideCameraMovePanel: null,
    showHidePanels: null,
    hideLists: null,
    showLists: null,
    sectionLens: null,
    sectionDepthOfField: null,
    sectionMovement: null,
    sectionPerspective: null,
    correctionStrength: null,
    focalLength: null,
    clippingPlane: null,
    fStop: null,
    focusDistance: null,
    movementSpeed: null,
    rotationSpeed: null,
    cameraBounds: null,
    skyLightIntensity: null,
    fogDensity: null,
    exposure: null,
    sunPitch: null,
    sunYaw: null,
    sunIntensity: null,
    sunTemperature: null,
    sunLightSourceAngle: null,
    autoVerticalAlignment: null,
    sectionExposureAndInterior: null,
    sectionSkyAndFog: null,
    sectionFogColor: null,
    sectionMeshes: null,
    sectionLights: null
  },
  'models.ueStreamings.'
);
